export enum FormInvoiceReportsCtrls {
  startDate = 'startDate',
  endDate = 'endDate'
}

export const HEADER_CLASS = {
  style: { 'text-align': 'left' }
}
